import { Locker } from "shared/locker"
import { SstLocker } from "shared/sst"
import i18n from "src/i18n/i18n"

// LOCKER-509: a V2 locker's dsync push omits `sstLocker` (an identical copy of
// `sst2Locker`), so the fallback reads `sst2Locker` when `sstLocker` is absent.
const sstSnapshot = (locker?: Locker) =>
  (locker?.sstLocker ?? locker?.sst2Locker) as SstLocker | undefined

const useLockerDisplayValues = (locker?: Locker) => {
  const lang = i18n.language
  const sst = sstSnapshot(locker)

  const name = locker?.name || sst?._id || "-"

  const displayValues = {
    name,
    description: locker?.description || "-",
    address1: locker?.address1 || sst?.address_1 || "-",
    address2: locker?.address2 || sst?.address_2 || "-",
    city: locker?.city || sst?.city || "-",
    province: locker?.province || sst?.province || "-",
    country: locker?.country || sst?.country || "-",
    postalCode: locker?.postalCode || sst?.postal_code || "-",
    latitude: locker?.latitude || sst?.latitude || "-",
    longitude: locker?.longitude || sst?.longitude || "-",
    lockerLocation: locker?.lockerLocation || "-",
    displayOrder: locker?.displayOrder || "-",
    nbDoors: locker?.sstLocker?.doors?.length || locker?.sst2Locker?.doors?.length || "-",
    i18n: {
      name:
        (lang === "en"
          ? locker?.nameEn
          : lang === "fr"
            ? locker?.nameFr
            : locker?.name) ||
        name ||
        "-",
      lockerLocation:
        (lang === "en"
          ? locker?.lockerLocationEn
          : lang === "fr"
            ? locker?.lockerLocationFr
            : locker?.lockerLocation) || "-",
    },
  }

  return displayValues
}

export default useLockerDisplayValues

// standard function version
export const getLockerDisplayValues = (locker: Locker) => {
  const lang = i18n.language
  const sst = sstSnapshot(locker)

  const name = locker?.name || sst?._id || "-"

  const displayValues = {
    name,
    description: locker?.description || "-",
    address1: locker?.address1 || sst?.address_1 || "-",
    address2: locker?.address2 || sst?.address_2 || "-",
    city: locker?.city || sst?.city || "-",
    province: locker?.province || sst?.province || "-",
    country: locker?.country || sst?.country || "-",
    postalCode: locker?.postalCode || sst?.postal_code || "-",
    latitude: locker?.latitude || sst?.latitude || "-",
    longitude: locker?.longitude || sst?.longitude || "-",
    lockerLocation: locker?.lockerLocation || "-",
    displayOrder: locker?.displayOrder || "-",
    nbDoors: locker?.sstLocker?.doors?.length || locker?.sst2Locker?.doors?.length || "-",
    i18n: {
      name:
        (lang === "en"
          ? locker?.nameEn
          : lang === "fr"
            ? locker?.nameFr
            : locker?.name) ||
        name ||
        "-",
      lockerLocation:
        (lang === "en"
          ? locker?.lockerLocationEn
          : lang === "fr"
            ? locker?.lockerLocationFr
            : locker?.lockerLocation) || "-",
    },
  }

  return displayValues
}
